import { useState, useEffect } from 'react'
import { InteractorProductCategoryMain } from '../Main'

const InteractorProductCategory = (main = '', major = '') => {
  const { listMainCategory } = InteractorProductCategoryMain()
  const [optionMain, setOptionMain] = useState([])
  const [optionMajor, setOptionMajor] = useState([])
  const [optionMinor, setOptionMinor] = useState([])
  const [loadingMain, setLoadingMain] = useState(false)
  const [optionCategory, setOptionCategory] = useState([])

  useEffect(() => {
    listMainCategory(setOptionMain, setLoadingMain)
  }, [listMainCategory])

  useEffect(() => {
    if (Object.keys(optionMain).length > 0 && optionCategory.length < 1) {
      let tempCategory = []
      optionMain?.main?.forEach((mainList) => {
        mainList?.major?.forEach((majorList) => {
          majorList?.minor?.forEach((minorList) => {
            tempCategory.push({
              main_uid: mainList.uid,
              main_name: mainList.name,
              major_name: majorList.name,
              major_uid: majorList.uid,
              minor_name: minorList.name,
              minor_uid: minorList.uid,
              label: `${mainList.name} / ${majorList.name} / ${minorList.name}`,
            })
          })
        })
      })
      setOptionCategory(tempCategory)
    }
  }, [optionCategory.length, optionMain])

  useEffect(() => {
    if (typeof main === 'string') {
      if (main) {
        const majorList = optionMain?.main?.filter((item) => item.uid === main)[0].major
        setOptionMajor(majorList)
        if (major) {
          const minorList = majorList?.filter((item) => item.uid === major)[0].minor
          setOptionMinor(minorList)
        }
      }
    } else if (typeof main === 'object') {
      if (main) {
        setOptionMajor(main?.major)
        if (major) {
          setOptionMinor(major?.minor)
        }
      }
    }
  }, [main, major, optionMain?.main])

  const handleOptionMain = (callback) => {
    callback('productCategoryMajor', null)
    callback('productCategoryMinor', null)
  }

  const handleOptionMajor = (callback) => {
    callback('productCategoryMinor', null)
  }

  return {
    optionMain,
    optionMajor,
    optionMinor,
    optionCategory,
    loadingMain,
    handleOptionMain,
    handleOptionMajor,
  }
}

export default InteractorProductCategory
